import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactGA from 'react-ga4';
//import reportWebVitals from './reportWebVitals';

import {
  DataStore,
  Environment,
  Logger
} from 'common';

const traceId = DataStore.get("TRACE_ID");

window.WETICKET_VERSION_INFO = {
  versionId: process.env.WETICKET_VERSION_ID,
  buildTime: process.env.WETICKET_BUILD_TIME,
};

if (!traceId) {

  let newTraceId;

  try {
    newTraceId = crypto && crypto.randomUUID ? crypto.randomUUID() : generateFallbackTraceId();
  } catch (e) {
    newTraceId = generateFallbackTraceId();
  }

  if (!newTraceId) {
    newTraceId = generateFallbackTraceId();
  }

  DataStore.set("TRACE_ID", newTraceId);
}

if (!DataStore.isSessionStorageAvailable()) {
  Logger.info('DataStore', 'isSessionStorageAvailable', 'SESSION_STORAGE_UNAVAILABLE');
}

// Fallback trace ID generator for environments where crypto.randomUUID is not available
function generateFallbackTraceId() {
  return 'trace-' + Date.now() + '-' + Math.random().toString(36).substring(2, 9);
}

const rootElement = document.getElementById('root');
if (rootElement) {

  if (Environment.name === 'Production') {
    ReactGA.initialize('G-XDPFGEDP9P');
  }

  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

window.initWidget2 = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    const root = createRoot(element);
    root.render(
      <React.StrictMode>
        <App widget={true} />
      </React.StrictMode>
    );
  }
};

serviceWorkerRegistration.unregister();
//reportWebVitals();